<h3 mat-dialog-title>Alterar Ativo da Carteira do Cliente</h3>

<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline" *ngIf="!novoCadastro">
                <mat-label>Ativo</mat-label>
                <input 
                    matInput 
                    placeholder="Ativo" 
                    [formControl]="ativo"
                    readonly
                    maxlength="255">                
            </mat-form-field>
            
            <mat-form-field style="width: 100%" appearance="outline" *ngIf="novoCadastro">
                <mat-label>Ativo</mat-label>
                <input matInput placeholder="Digite o ativo" aria-label="Ativo"  [formControl]="ativo" name="ativo" [matAutocomplete]="auto2">
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                    <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                        <span>Empresa: {{ativo.nome}}</span> |
                        <small>Sigla: {{ativo.sigla }}</small>
                    </mat-option>
                </mat-autocomplete>            
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
            </mat-form-field>                

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Quantidade</mat-label>
                <input 
                    matInput 
                    placeholder="Quantidade" 
                    [formControl]="qtd" 
                    required
                    maxlength="20"
                    style="text-align: right;">       
                <mat-error *ngIf="qtd.invalid">{{getErrorQtdMessage()}}</mat-error>         
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Preço Executado</mat-label>
                <input 
                    matInput 
                    placeholder="Preço Executado" 
                    [formControl]="preco_executado" 
                    required
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    maxlength="50"                    
                    (ngModelChange)="montaValor()">                    
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Valor Financeiro</mat-label>
                <input 
                    matInput 
                    placeholder="Valor Financeiro" 
                    [formControl]="vlr_financeiro" 
                    required
                    currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    maxlength="50">
                <mat-error *ngIf="vlr_financeiro.invalid">{{getErrorFinanceiroMessage()}}</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Migrado</mat-label>
                <mat-select                     
                    [(ngModel)]="model.migrado" 
                    [formControl]="migrado" 
                    name="migrado"
                >
                    <mat-option value="false">NÃO</mat-option>                     
                    <mat-option value="true">SIM</mat-option>
                </mat-select>
            </mat-form-field>

            <div fxLayout="row" fxLayoutAlign="space-between" >
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Estratégia</mat-label>
                    <mat-select 
                        placeholder="Estratégia"
                        [(value)]="model.estrategia_id" 
                        [formControl]="estrategia_id"                                            
                        name="estrategia_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option 
                            *ngFor="let estrategia of listEstrategia" 
                            [value]="estrategia.id"
                        >
                            {{estrategia.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                </mat-form-field>
            </div>   
            
            <div fxLayout="row" fxLayoutAlign="space-between" >
                <div fxFlex.gt-sm="50" fxFlex="100" class="p-10" style="margin-bottom:10px; float: left;">
                    <mat-checkbox 
                        [formControl]="ativo_casado" 
                        name="ativo_casado"
                        style="margin-bottom:10px; float: left;">
                        Ativo Lançado
                    </mat-checkbox>                
                </div>                
                <div fxFlex.gt-sm="50" fxFlex="100" class="p-10" style="margin-bottom:10px; float: left;">
                    <mat-checkbox 
                        [formControl]="ativo_bloqueado" 
                        name="ativo_bloqueado">
                        Ativo Bloqueado
                    </mat-checkbox>                
                </div>
            </div>
            
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>